export const ru = {
    'be-sure-no-error': 'Вы попали на несуществующую страницу',
    info: 'Вероятно, это произошло из-за опечатки или неправильной раскладки клавиатуры'
};
